import { RoomCustomer } from "../../../../models/room";
import { RoomOwnerDTO } from "../dtos/read-room.api.dto";

export const mapRoomsByUserId = (room: RoomOwnerDTO): RoomCustomer => {
  return {
    _id: room._id,
    name: room.name,
    monitorId: room.monitorId || "",
    address: room.address || "",
    phone: room.phone || "",
    status: room.status || "",
    // Deprecated fields but still used in some parts of the app
    licenseId: "",
    serviceContractId: "",
    licenses: room.licenses.map((license) => ({
      serviceContractId: license.serviceContractId,
      licenseId: license.licenseId,
      productId: license.productId,
    })),
  };
};
